const AllProductsTable = ({ data }) => {
  return (
    <div>
      <h3>Tous les produits</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #00ff00' }}>
            <th style={{ textAlign: 'left', color: '#00ff00' }}>Nom</th>
            <th style={{ textAlign: 'left', color: '#00ff00' }}>Click</th>
          </tr>
        </thead>
        <tbody>
          {data.map((product) => (
            <tr key={product.productId} style={{ borderBottom: '1px solid #00ff00' }}>
              <td style={{ color: '#fff' }}>{product.productId}</td>
              <td style={{ color: '#fff' }}>{product.productName}</td>
              <td style={{ color: '#fff' }}>{product.clickCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllProductsTable;
